import { useEffect, useState } from 'react';
import { Drawer, Grid, List, ListItem, ListItemIcon, ListItemText, Toolbar } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const drawerWidth = 80;
const Sidebar = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState('/roles?param=0');
  const baseUrl = window.location.origin;

  const handleItemClick = (route: any) => {
    navigate(route);
    setActiveItem(route);
  };

  useEffect(() => {
    setActiveItem(window.location.pathname + window.location.search);
  }, []);

  const list = () => (
    <List sx={{ pt: '20px', cursor: 'pointer' }}>
      {[
        // { text: 'Home', imageURL: 'Home.svg', route: '/dashboard' },
        { text: 'Roles', imageURL: 'Roles.svg', route: '/roles?param=0' },
        { text: 'Modules', imageURL: 'module.svg', route: '/module' },
        { text: 'Sub-Modules', imageURL: 'submodule.svg', route: '/sub-module' },
      ].map(({ text, imageURL, route }) => (
        <ListItem
          sx={{
            alignContent: 'space-between',
            alignItems: 'center',
            color: '#fff',
            display: 'grid',
            justifyContent: 'center',
            borderLeft: activeItem === route ? '3px solid #DE4E35' : 'none',
          }}
          key={text}
          onClick={() => handleItemClick(route)}
        >
          <ListItemIcon sx={{ display: 'block', textAlign: 'center' }}>
            <img src={`${baseUrl}/${imageURL}`} alt="svg" />
          </ListItemIcon>
          <ListItemText sx={{ textAlign: 'center' }} primary={text} />
        </ListItem>
      ))}
    </List>
  );
  return (
    <Grid>
      <Drawer
        className="side-bar-container"
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            background: '#2559C3',
          },
        }}
      >
        <Toolbar />
        {list()}
      </Drawer>
    </Grid>
  );
};

export default Sidebar;
